import React from 'react';
import { motion } from 'framer-motion';

const SlotReels = ({ isSpinning, reels, heldReels, onToggleHold }) => {
  
  // Helper to determine font size based on text length
  const getFontSize = (text) => {
    const len = text.length;
    if (len < 8) return 'text-xl md:text-2xl';   // Short text (e.g. "SELECT")
    if (len < 15) return 'text-sm md:text-lg';   // Medium text (e.g. "FROM Users")
    if (len < 25) return 'text-xs md:text-sm';   // Long text
    return 'text-[10px] leading-tight';          // Very long text
  };

  return (
    <div className="grid grid-cols-5 gap-2 w-full h-24 md:h-32 perspective-1000">
      {reels.map((symbol, index) => {
        const isHeld = heldReels[index];
        const fontSizeClass = getFontSize(symbol);

        return (
          <div 
            key={index}
            onClick={() => onToggleHold(index)}
            className={`
              relative h-full rounded-lg border-2 shadow-inner overflow-hidden cursor-pointer group transition-all duration-300
              ${isHeld 
                ? 'bg-yellow-900/40 border-yellow-500 shadow-[0_0_15px_rgba(234,179,8,0.4)]' 
                : 'bg-gradient-to-b from-slate-800 to-black border-slate-600 hover:border-white/50'}
            `}
          >
            {/* Hold Indicator */}
            {isHeld && (
              <div className="absolute top-1 right-1 z-20">
                <div className="w-2 h-2 rounded-full bg-yellow-500 animate-pulse shadow-[0_0_5px_rgba(234,179,8,1)]"></div>
              </div>
            )}

            {/* The Reel Content */}
            <div className="relative h-full w-full flex items-center justify-center p-1 text-center">
              
              {/* Blur Effect when Spinning */}
              {isSpinning && !isHeld ? (
                <motion.div 
                  animate={{ y: [0, 100, -100, 0] }}
                  transition={{ duration: 0.2, repeat: Infinity, ease: "linear" }}
                  className="absolute inset-0 flex flex-col items-center justify-center opacity-50 blur-sm"
                >
                  <span className="text-slate-500 font-bold text-lg block my-4">SELECT</span>
                  <span className="text-slate-500 font-bold text-lg block my-4">FROM</span>
                  <span className="text-slate-500 font-bold text-lg block my-4">WHERE</span>
                </motion.div>
              ) : (
                <motion.div
                  key={symbol}
                  initial={{ y: -50, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  className={`font-black font-mono text-white break-words w-full ${fontSizeClass}`}
                >
                  {symbol}
                </motion.div>
              )}

              {/* Glass Reflection Overlay */}
              <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent pointer-events-none rounded-lg"></div>
            </div>
            
            {/* Hold Overlay Text (On Hover) */}
            {!isSpinning && (
                <div className="absolute inset-x-0 bottom-0 bg-black/80 text-[8px] md:text-[10px] text-center text-slate-400 py-0.5 opacity-0 group-hover:opacity-100 transition-opacity">
                    {isHeld ? 'RELEASE' : 'HOLD'}
                </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SlotReels;